import { render, staticRenderFns } from "./DefaultAction.vue?vue&type=template&id=0283f70c&"
import script from "./DefaultAction.vue?vue&type=script&lang=js&"
export * from "./DefaultAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports